import { MDSDropdown } from '@marqvision/mds-v2';
import { MarqCommonEnumsCommentCommentUserTypeEnum } from '~/swagger/data-contracts';
import { ResponsiveProps } from '../Responsive/@types';
import { useListingCommentFilter } from './@hooks/useListingCommentFilter';

export const ListingCommentFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const listingCommentOptions = useListingCommentFilter();

  return (
    <MDSDropdown
      label="Comments"
      value={listingCommentOptions.selected}
      list={listingCommentOptions.list}
      isDisabled={listingCommentOptions.disabled}
      isLoading={listingCommentOptions.isFetching}
      onChange={(value: MarqCommonEnumsCommentCommentUserTypeEnum | null) => listingCommentOptions.select(value)}
      modules={[
        'hide-select-all',
        {
          type: 'filter-button',
          size,
        },
      ]}
    />
  );
};
